.successIcon {
  font-size: var(--ant-font-size-heading-1);
  color: var(--ant-color-success);
}

.heading.heading {
  margin: 0;
}

.messagePreview.messagePreview {
  width: 100%;
  margin: 0;
  padding: var(--ant-padding-sm);
  border-radius: var(--ant-border-radius);
  background: var(--ant-color-fill-quaternary);
  white-space: pre-wrap;
  font-family: var(--ant-font-family-code);
}
